module.exports = __webpack_public_path__ + "media/img/contact-us/offices/ukraine-a35538606555251a2909deda4531b1ca.svg";